// src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import allWardsSlice from "pages/AllWards/allWardsSlice";
import articlesSlice from "pages/ArticlesApprovalManagement/articlesSlice";
import counsilorSlice from "pages/Councillors/counsilorSlice";
import roleSlice from "pages/ManageRoles/roleSlice";
import notificationDestinationSlice from "pages/Notification/notificationDestinationSlice";
import notificationMediaSlice from "pages/Notification/notificationMediaSlice";
import userSlice from "pages/UserManagement/userSlice";

export const store = configureStore({
  devTools: true,
  reducer: {
    roles: roleSlice,
    users: userSlice,
    counsilor: counsilorSlice,
    wards: allWardsSlice,
    projects: articlesSlice,
    notificationMedia: notificationMediaSlice,
    notificationDestination: notificationDestinationSlice,
  },
});
